
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use_cases",
      function () {
        return require("private-next-pages/use_cases.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use_cases"])
      });
    }
  